import { Skeleton } from "@/components/ui/skeleton"

/**
 * OKS-477 — §07 loading state (Figma `47:264`). Hero-shaped block + two
 * card-shaped blocks (NOT a spinner — UX Spec §3), sized to the real layout
 * so there's no shift on resolve. Shown during a client refetch.
 */
export function DropSkeleton() {
  return (
    <div
      className="flex flex-col gap-4"
      data-testid="drop-skeleton"
      aria-busy="true"
      aria-live="polite"
    >
      <Skeleton className="h-36 w-full rounded-2xl" />
      {/* OKS-986 — h-64, not h-56: every card on this screen is a drop, and a
          drop that has fired now carries the gift row (48px tile + two text
          lines). The block is sized to the taller, post-986 card so the reveal
          does not shift.

          OKS-988 — h-80, not h-64: a TTL-flagged card additionally carries the
          recency line (~20px) and a secondary text action (44px + gap).

          ⚠️ Same limitation as the detail skeleton: this cannot know which
          shape resolves, and it is sized to the FLAGGED card — the shape UX §3
          names. An unflagged card settles upward slightly. Deliberate: content
          settling up is less disruptive than the action row being pushed down
          after the reader has reached for it. */}
      {[0, 1].map((i) => (
        <Skeleton key={i} className="h-80 w-full rounded-xl" />
      ))}
    </div>
  )
}
